export const operationType = {
    ADD:'ADD',
    EDIT:'EDIT',
};